var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53957 1.77914C4.65211 0.766272 5.50824 0 6.52733 0H13.4734C14.4925 0 15.3486 0.766272 15.4612 1.77914L15.4974 2.10547H16.9998C18.6567 2.10547 19.9998 3.44861 19.9998 5.10547V12.2632C19.9998 13.9201 18.6567 15.2632 16.9998 15.2632H3C1.34315 15.2632 0 13.9201 0 12.2632V5.10547C0 3.44861 1.34315 2.10547 3 2.10547H4.50331L4.53957 1.77914ZM9.99966 12.1054C11.7437 12.1054 13.1575 10.6916 13.1575 8.94758C13.1575 7.20354 11.7437 5.78971 9.99966 5.78971C8.25562 5.78971 6.8418 7.20354 6.8418 8.94758C6.8418 10.6916 8.25562 12.1054 9.99966 12.1054Z",
    fill: "#D9D9D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add_image.a47b8b414d56e8413c8f35ff7e0b4331.svg";
export { ForwardRef as ReactComponent };